import React from "react";
import { FormBuyTokens } from "../../component/FormBuyTokens/FormBuyTokens";
import { connect } from "react-redux";
import Header  from "../../component/Header/Header";
import classes from './BuyToken.module.scss'
import { useTranslation } from "react-i18next";

const BuyToken = (props:any) => {
    const {t} = useTranslation()
    return(
        <div className={classes.token}>
            <div className="g-container">
                <div className={classes.token__wrapper}>
                    <Header />
                    <div className={classes.token__wrapper__form}>
                        <p className={classes.token__wrapper__form_title}>{t('buyTokens')}</p>
                        <FormBuyTokens status = {props.data.identificationStatus}/>
                    </div>
                    <div className={classes.token__wrapper_blur1}/>
                    <div className={classes.token__wrapper_blur2}/>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    data: state.AuthReducer,
})
  
export default connect(mapStateToProps, {})(BuyToken)